import base64 from '../global/base64.js';
import md5 from '../global/md5.js';
import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import axios from 'axios';


const fSmApiReq = async ({
  sReqUrl,
  sMethodName,
  sReqJn,
  sMchId,
  sUserId,
  sSignType = 'TOKEN',
  sReqToken,
  sOrgAk,
  sOrgSk,
}) => {
  //       // 验签秘钥

  // 请求参数BASE64
  //  #ifdef MP-ALIPAY
  // let sReqJnBase64 = base64.Base64.encode(sReqJn);
  //  #endif
  //  #ifdef MP-WEIXIN || H5
  let sReqJnBase64 = Base64.encode(sReqJn);
  //  #endif

  let sReqTime = timeHelper.fGetNowTime(2);

  let js = {};
  js['METHOD_NAME'] = sMethodName;
  js['REQ_JSON'] = sReqJnBase64;
  js['MCH_ID'] = sMchId;
  js['USER_ID'] = sUserId;
  js['REQ_FROM'] = 'WMIN';
  js['REQ_VER'] = '20250710';
  js['REQ_TIME'] = sReqTime;
  js['SIGN_TYPE'] = sSignType;
  js['REQ_LNG'] = 'zh-CN'
  js['REQ_APP'] = 'smSellAdmin'
  js['APP_NAME'] = 'smSellAdmin'

  // 组装签名
  if (sSignType == 'MD5') {
    let sSign
    sSign = sOrgAk + sReqJnBase64 + sReqTime + sOrgSk;
    sSign = md5(sSign);
    sSign = sSign.toLowerCase();
    js['ORG_AK'] = sOrgAk
    js['REQ_SIGN'] = sSign
  } else {
    js['REQ_TOKEN'] = sReqToken
  }

  // 发起请求
  console.log(js)
  console.log(JSON.parse(sReqJn))
  let res = await axios.post(sReqUrl, js);
  console.log(res)
  // 隐藏加载动画

  // 请求结果校验
  // if (!uni.$u.test.object(res)) {
  // 	uni.showModal({
  // 		title: '提示',
  // 		content: res,
  // 		showCancel: false,
  // 	})
  // 	return {
  // 		result: 'sucess',
  // 		msg: res
  // 	};
  // }

  // token 失效处理
  if (res.result !== 'success' && res.msg === 'tokenFail') {
    // TODO: 触发重新登录或刷新 token 的逻辑
  }

  return res.data;
};



//管理api
const fSmCloudAdminApi = (obj) => {
  let sReqUrl = 'https://www.91byk.com/smApi/smSellMain/smCloudAdmin/adminApi';
  return fSmApiReq({
    sReqUrl,
    sMethodName: obj.sMethodName,
    sReqJn: JSON.stringify(obj.sReqJn),
    sMchId: obj.sMchId,
    sUserId: obj.sUserId,
    sSignType: obj.sSignType,
    sOrgAk: obj.sOrgAk,
    sOrgSk: obj.sOrgSk,
  });
};
//查询api
const fSmCloudQueryApi = (obj) => {
  let sReqUrl = 'https://www.91byk.com/smApi/smSellMain/smCloudQuery/queryApi';
  return fSmApiReq({
    sReqUrl,
    sMethodName: obj.sMethodName,
    sReqJn: JSON.stringify(obj.sReqJn),
    sMchId: obj.sMchId,
    sUserId: obj.sUserId,
    sSignType: obj.sSignType,
    sOrgAk: obj.sOrgAk,
    sOrgSk: obj.sOrgSk,
  });
};


export default {
  fSmCloudAdminApi,
  fSmCloudQueryApi
}



//////////////////
// WEBPACK FOOTER
// ./common/api/smCloudApi.js
// module id = 9OF5
// module chunks = 210